import { PropsWithChildren } from 'react'
import styles from 'features/contracts/add/components/producer-card-layout/ProducerCardLayout.module.scss'
import { ProducerCardLayoutProps } from 'features/contracts/add/components/producer-card-layout/types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import ProducerLocation from 'components/producer-location/ProducerLocation'
import { useGetLanguage } from 'hooks/use-get-language'
import { getProducerLocation } from 'utils/producer.ts'

const ProducerCardLayout = ({
  producer,
  hideProducerImage,
  hideProducerLocation,
  className,
  headerClass,
  children,
  loading
}: PropsWithChildren<ProducerCardLayoutProps>) => {
  // i18n
  const { t } = useTranslation('producer')
  const lowerCaseLanguage = useGetLanguage('lowercase')

  return !loading && producer ? (
    <div className={styles.card}>
      {/* CARD HEADER */}
      {!hideProducerImage && (
        <figure className={classNames(styles['card-header'], headerClass)}>
          <img
            src={producer.images.profile?.url}
            alt={t(($) => $.alt, {
              producer: producer.name.nl,
              interpolation: { escapeValue: false }
            })}
          />
          {!hideProducerLocation && (
            <ProducerLocation
              {...producer}
              location={getProducerLocation(lowerCaseLanguage, producer?.location)}
              className={styles.location}
            />
          )}
        </figure>
      )}

      {/* CARD CONTENT */}
      <div className={classNames(styles['card-content-container'], { [styles['fully-boxed']]: hideProducerImage }, className)}>
        {children}
      </div>
    </div>
  ) : loading ? (
    <div className={classNames(styles.card, styles.skeleton)}>
      <div className={styles['card-header']} />

      <div className={styles['card-content-container']}>
        <div className={styles.loader} />
        <div className={styles.loader} />
        <div className={styles.loader} />
      </div>
    </div>
  ) : (
    <></>
  )
}

export default ProducerCardLayout
